/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTkuNzMyOTUgM0w2LjkyMDQ1IDEzLjQ0ODlINkw4LjgxMjUgM0g5LjczMjk1WiIgZmlsbD0iaW5oZXJpdCIvPg==";